/**
 * Checks whether the current pathname finishes by '/edit'.
  * @private
 * @param  {string} path
 * @returns {boolean}
 */
function isEditRouteUtil (path) {
  if (!path) {
    return false
  }
  return !!path.endsWith('/edit')
}

export default isEditRouteUtil
